export default __webpack_public_path__ + "static/media/logo-hingo.cdcf2973.svg";